import React from 'react';

const SecurityModal = ({
  isOpen,
  setIsOpen,
  inputValue,
  handleInputChange,
  handleAddAmenities,
}) => {
  if (!isOpen) return null;

  return (
    <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
      <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
        <h2 className="oms-modal-title">Add Security</h2>
        <form
          className="oms-modal-form"
          onSubmit={(e) => {
            e.preventDefault();
            handleAddAmenities();
          }}
        >
          <div className="oms-form-group">
            <label htmlFor="security" className="oms-form-label">Security</label>
            <input
              type="text"
              id="security"
              name="security"
              value={inputValue}
              onChange={handleInputChange}
              placeholder="Enter Security"
              required
            />
          </div>

          <div className="oms-form-actions">
            <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
            <button type="submit">Add</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SecurityModal;
